export default __webpack_public_path__ + "5d67f4446248e51b55498bd987eaed65.png";